export const toLocalDateOnly = (date: Date): string => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getTodayLocalDateOnly = (): string => toLocalDateOnly(new Date());

export const getLocalDateOnlyFromValue = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return value.slice(0, 10);
  }

  // Comentario em pt-BR: esse helper evita virar o dia em UTC e baguncar streak, foco e calendario.
  return toLocalDateOnly(parsedDate);
};
